import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const ArrowDownward = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z" />
  </IconSvg>
);

export default ArrowDownward;
